export const bladeGuide = {
  padding: "40px",
};

export const bladesContainer = ({ isMobile }) => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  flexWrap: !isMobile ? "wrap" : null,
  mx: isMobile ? "0" : "-10px",
});

export const blade = ({ isMobile }) => ({
  px: isMobile ? "0" : "10px",
  pb: "40px",
  width: isMobile ? "100%" : "50%",
});

export const image = {
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "50% 50%",
  borderRadius: "8px",
  border: "solid 1px",
  borderColor: "grey5",
  mb: "15px",

  height: "0px",
  width: "100%",
  pt: `${(150 / 285) * 100}%`,
};
